module.exports = __webpack_public_path__ + "img/xuqiu.f664139b.png";